<div class="modal-container">
  <h1 i18n>Are you sure about this?</h1>
  <section class="buttons">
    <button class="close-button" (click)="closeModal(false)" i18n>No</button>
    <button class="submit-button" (click)="closeModal(true)" i18n>Yes</button>
  </section>
</div>
